export const BUSINESS = {
  name: "A+ Detailing",
  tagline: "Sioux Falls' Premier Luxury Auto Detailing Studio",
  phone: "605-799-5882",
  phoneHref: "tel:+16057995882",
  email: "aplusdetailing605@gmail.com",
  street: "601 S Lyons Ave. Suite 300",
  city: "Sioux Falls",
  region: "SD",
  zip: "57106",
  address: "601 S Lyons Ave. Suite 300, Sioux Falls, SD 57106",
  domain: "https://www.aplusdetailing.info",
};

const W = (id, w, h) =>
  `https://static.wixstatic.com/media/${id}/v1/fill/w_${w},h_${h},al_c,q_85,enc_avif,quality_auto/${id}`;

export const HERO_PHOTO = W("bdfde5_fd7e5657e1d34b508e89a766042b9046~mv2.jpg", 1920, 1200);

export const PHOTOS = [
  { id: "bdfde5_fd7e5657e1d34b508e89a766042b9046~mv2.jpg", alt: "Customer vehicle detailed by A+ Detailing in Sioux Falls, SD" },
  { id: "bdfde5_e42d347aa09b43d69744b7e36743f02a~mv2.jpeg", alt: "Customer vehicle finished by A+ Detailing Sioux Falls" },
  { id: "bdfde5_722e119b9fe64c2d8249a2f785eb8557~mv2.jpg", alt: "Customer vehicle exterior work by A+ Detailing" },
  { id: "bdfde5_f5f2bff74698484d97fbf9aaee32ad32~mv2.jpg", alt: "A+ Detailing customer vehicle in the studio" },
  { id: "bdfde5_f4e30ac9f68d4119a1eed2d5b461d07f~mv2.jpg", alt: "Vehicle work by A+ Detailing Sioux Falls" },
  { id: "bdfde5_266f1eeac90b49d48ab133802ca3dce9~mv2.jpg", alt: "Customer vehicle gloss finish by A+ Detailing" },
  { id: "bdfde5_f45ce589b00a4ca2afda8899b7134660~mv2.jpg", alt: "Vehicle detailed at A+ Detailing Sioux Falls, SD" },
];

export const photo = (i, w, h) => W(PHOTOS[i % PHOTOS.length].id, w, h);

export const PACKAGES = [
  {
    name: "Interior Detail",
    slug: "interior-detailing",
    price: 275,
    mobilePrice: 300,
    blurb:
      "A complete cabin reset — comprehensive vacuum, crevices cleared of dirt & grime, streak-free glass and leather conditioned to a grease-free matte finish.",
    includes: [
      "Comprehensive vacuum",
      "Interior crevices cleared from dirt & grime",
      "Windows cleaned with a streak-free finish",
      "All leather surfaces cleaned & conditioned",
      "All door, panels & dash cleaned",
    ],
  },
  {
    name: "Full Auto Detailing",
    slug: "full-detailing",
    price: 325,
    mobilePrice: 350,
    blurb:
      "The complete inside-and-out package — 2-bucket hand wash, wheels, tires & fender wells, bug removal and the full interior detail.",
    includes: [
      "2-bucket hand wash & dry",
      "Tires & fender wells cleaned & conditioned",
      "Wheels cleaned",
      "Streak-free glass",
      "Bug removal",
      "Comprehensive vacuum",
      "Interior crevices cleared from dirt & grime",
      "All leather surfaces cleaned & conditioned",
      "All door, panels & dash cleaned",
    ],
  },
  {
    name: "The Exclusive",
    slug: "full-detailing",
    price: 450,
    mobilePrice: 500,
    featured: true,
    blurb:
      "Our flagship package — everything in the full detail plus decontamination, clay bar, pet hair removal and Rupes Advanced Nano protectant with 8 months of protection.",
    includes: [
      "Everything in Full Auto Detailing",
      "Rupes Advanced Nano protectant — 8 months protection",
      "Exhaust tips cleaned",
      "Wheels decontaminated & cleaned",
      "Tire shine",
      "Clay bar treatment",
      "Tar removal",
      "Pet hair removal",
      "Fresh scent applied",
    ],
  },
];

export const UPGRADES = [
  { name: "Carpet, Headliner Shampooing & Stain Removal with Extraction", price: 100 },
  { name: "Seat Shampooing & Stain Removal with Extraction", price: 100 },
  { name: "Seats, Carpet & Headliner Shampooing & Stain Removal with Extraction", price: 150 },
  { name: "Odor Remover — Ozone Machine & Car Bomb", price: 80 },
  { name: "Engine Bay Steam Cleaned", price: 80 },
];

export const PAINT_CORRECTION = {
  price: 400,
  blurb:
    "2-step paint correction restores and enhances your vehicle's paintwork by removing imperfections such as swirl marks, scratches and oxidation — a cutting/compounding stage followed by a refining polish.",
  stages: [
    { name: "Cut & Compound", desc: "Machine compounding removes swirl marks, light scratches and oxidation from the clear coat." },
    { name: "Polish & Refine", desc: "A refining polish stage maximizes gloss, clarity and mirror-like reflections." },
  ],
};

export const CERAMIC = [
  {
    name: "System X Pro",
    price: 1800,
    warrantyLine: "Up to 6 years of protection · 6-year warranty",
    blurb:
      "The professional standard for premium daily drivers — semi-permanent, ultra-hydrophobic 9H ceramic with a self-cleaning, high-gloss finish.",
    features: [
      "Up to 6 years of relentless protection",
      "Ultra-hydrophobic, self-cleaning finish that repels dirt and grime",
      "9H hardness for superior scratch resistance",
      "High-gloss finish that enhances your paint",
      "Shields against UV rays, oxidation and corrosion",
      "Boeing-approved chemical resistance",
      "Applied to automotive paint and gel coat",
      "Registered to your vehicle's Carfax",
    ],
  },
  {
    name: "System X Max G+",
    price: 2000,
    featured: true,
    warrantyLine: "Up to 10 years of protection · Lifetime warranty",
    blurb:
      "Redefines professional-grade ceramic — superior gloss and protection for paint, gel coat, wraps and PPF.",
    features: [
      "Up to 10 years of long-lasting protection",
      "30% glossier finish with improved gloss retention",
      "Exceptional slickness for easy cleaning",
      "9H hardness for enhanced durability",
      "UV protection that prevents fading and oxidation",
      "High resistance to chemicals and environmental contaminants",
      "Safe for paint, gel coat, wraps and PPF",
      "Registered to your vehicle's Carfax",
    ],
  },
  {
    name: "System X Phantom",
    price: 2500,
    warrantyLine: "Lifetime warranty · Two-part ceramic system",
    blurb:
      "The industry's first professional two-part ceramic coating — a new benchmark in strength and longevity, trusted for automotive, aviation and marine use.",
    features: [
      "Industry's first professional two-part ceramic system with superior bonding",
      "Dramatically stronger cross-linked matrix — outperforms traditional coatings",
      "Hyper-durable ceramic shell with advanced hydrophobic properties",
      "Exceptional 9H hardness for superior scratch resistance",
      "Long-lasting UV protection that prevents fading",
      "Robust protection against corrosion and environmental damage",
      "Applied to automotive, aviation and marine surfaces",
      "Registered to your vehicle's Carfax",
    ],
  },
];

export const CERAMIC_NOTE =
  "Every ceramic coating booking includes a free paint correction before we coat, and your coating is registered to your vehicle's Carfax.";

export const SERVICES = [
  { name: "Interior Detailing", path: "/interior-detailing", desc: "Vacuum, crevices, glass & leather care", price: "From $275" },
  { name: "Full Detailing", path: "/full-detailing", desc: "Complete inside & out packages", price: "From $325" },
  { name: "Paint Correction", path: "/paint-correction", desc: "2-step swirl & scratch removal", price: "From $400" },
  { name: "Ceramic Coatings", path: "/ceramic-coatings", desc: "System X Pro, Max G+ & Phantom", price: "From $1,800" },
  { name: "Marine & Aviation Ceramic", path: "/marine-aviation-ceramic", desc: "System X Phantom for boats & aircraft", price: "Free quote" },
  { name: "Window Tinting", path: "/window-tinting", desc: "Automotive tint film", price: "Free quote" },
  { name: "Residential & Commercial Tint", path: "/residential-commercial-tinting", desc: "Home & business window film", price: "Free quote" },
  { name: "Paint Protection Film", path: "/paint-protection-film", desc: "PPF clear bra protection", price: "Free quote" },
];

export const FLAT_RATE_NOTE =
  "Every detailing package is a flat rate — pricing varies by the size of your vehicle, never its condition.";

export const fmt = (n) => `$${n.toLocaleString("en-US")}`;
